export default __webpack_public_path__ + "media/images/voisoNew/navbar/logo-c34e19cd023e60d5fe6428ce449c608c.svg";